// Page de gestion des utilisateurs
// Fichier: /var/www/squarecom/frontend/src/pages/Users.js

import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Chip,
  Avatar,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  CircularProgress,
  Alert,
  Switch,
  FormControlLabel
} from '@mui/material';
import {
  Add,
  Edit,
  MoreVert,
  Delete,
  Lock,
  Email
} from '@mui/icons-material';

function Users() {
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  // Dialogues
  const [createDialog, setCreateDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);

  // Formulaire nouvel utilisateur
  const [newUser, setNewUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: 'admin',
    password: '',
    apartmentNumber: '',
    isEmployee: false
  });

  // Formulaire édition
  const [editUser, setEditUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    role: '',
    password: '',
    apartmentNumber: '',
    isEmployee: false
  });

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('token');

      const response = await fetch('/api/users', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('🔍 DEBUG - Données utilisateurs reçues:', data);
        // Gérer différents formats de réponse possibles
        const usersList = data.users || data || [];
        console.log('🔍 DEBUG - Premier utilisateur:', usersList[0]);
        // FILTRER pour exclure les locataires (tenants)
        const filteredUsers = usersList.filter(user => user.role !== 'tenant');
        setUsers(Array.isArray(filteredUsers) ? filteredUsers : []);
      } else {
        throw new Error('Erreur lors du chargement des utilisateurs');
      }
    } catch (error) {
      console.error('Erreur:', error);
      setError('Impossible de charger les utilisateurs');
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateUser = async () => {
    try {
      const token = localStorage.getItem('token');

      // Générer un mot de passe temporaire si non fourni
      const userData = {
        ...newUser,
        password: newUser.password || 'TempPass123!'
      };

      const response = await fetch('/api/users', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(userData)
      });

      if (response.ok) {
        setCreateDialog(false);
        setNewUser({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          role: 'admin',
          password: '',
          apartmentNumber: ''
        });
        loadUsers();
      } else {
        const error = await response.json();
        alert(error.message || 'Erreur lors de la création');
      }
    } catch (error) {
      console.error('Erreur création:', error);
      alert('Erreur lors de la création de l\'utilisateur');
    }
  };

  const handleEditUser = async () => {
    try {
      const token = localStorage.getItem('token');

      // Filtrer le mot de passe vide
      const dataToUpdate = {...editUser};
      if (!dataToUpdate.password || dataToUpdate.password === '') {
        delete dataToUpdate.password;
      }

      const response = await fetch(`/api/users/${editUser.id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToUpdate)
      });

      if (response.ok) {
        setEditDialog(false);
        loadUsers();
      } else {
        const error = await response.json();
        alert(error.error || 'Erreur lors de la modification');
      }
    } catch (error) {
      console.error('Erreur modification:', error);
      alert('Erreur lors de la modification');
    }
  };

  const handleDeleteUser = async (userId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer cet utilisateur ?')) {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`/api/users/${userId}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          loadUsers();
        } else {
          const error = await response.json();
          alert(error.error || 'Erreur lors de la suppression');
        }
      } catch (error) {
        console.error('Erreur suppression:', error);
        alert('Erreur lors de la suppression');
      }
    }
  };

  const handleToggleActive = async (userId, currentStatus) => {
    console.log('🔴 handleToggleActive appelée !', { userId, currentStatus });
    try {
      const token = localStorage.getItem('token');
      console.log('🔴 Token:', token ? 'Présent' : 'Absent');
      
      const payload = { isActive: !currentStatus };
      console.log('🔴 Envoi de:', payload);
      
      const response = await fetch(`/api/users/${userId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      console.log('🔴 Réponse:', response.status, response.ok);

      if (response.ok) {
        console.log('🔴 Succès ! Rechargement...');
        loadUsers();
      } else {
        const error = await response.json();
        console.log('🔴 Erreur backend:', error);
        alert(error.error || 'Erreur lors de la modification du statut');
      }
    } catch (error) {
      console.error('🔴 Erreur changement statut:', error);
      alert('Erreur lors de la modification du statut');
    }
  };

  const handleResetPassword = async (userId) => {
    if (window.confirm('Réinitialiser le mot de passe de cet utilisateur ?')) {
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`/api/users/${userId}/reset-password`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          alert('Un email de réinitialisation a été envoyé');
        }
      } catch (error) {
        console.error('Erreur réinitialisation:', error);
      }
    }
  };

  const openEditDialog = (user) => {
    // Vérifier si l'utilisateur peut modifier ce compte
    if (user.role === 'superadmin' && currentUser.role !== 'superadmin') {
      alert('Vous ne pouvez pas modifier un compte Super Admin');
      return;
    }

    setEditUser({
      id: user.id,
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      email: user.email || '',
      phone: user.phone || '',
      role: user.role || 'admin',
      password: '',
      apartmentNumber: user.apartmentNumber || '',
      isEmployee: user.isEmployee || false
    });
    setEditDialog(true);
  };

  const getRoleChip = (role) => {
    const roleConfig = {
      superadmin: { label: 'Super Admin', color: 'error', variant: 'filled' },
      admin: { label: 'Administrateur', color: 'error' },
      manager: { label: 'Gestionnaire', color: 'warning' },
      contractor: { label: 'Sous-traitant', color: 'info' },
      technician: { label: 'Technicien', color: 'primary' }
    };

    const config = roleConfig[role] || { label: role, color: 'default' };
    return <Chip label={config.label} color={config.color} size="small" />;
  };

  const getInitials = (firstName, lastName) => {
    return `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toUpperCase();
  };

  if (loading) {
    return (
      <Container maxWidth="xl">
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      {/* ✅ MODIFICATION APPLIQUÉE : Container maxWidth="xl" au lieu de "lg" */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          Gestion des Utilisateurs
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => setCreateDialog(true)}
        >
          NOUVEL UTILISATEUR
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Utilisateur</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Téléphone</TableCell>
              <TableCell>Rôle</TableCell>
              <TableCell>Employé</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <Typography color="textSecondary">
                    Aucun utilisateur trouvé
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Avatar sx={{ width: 32, height: 32 }}>
                        {getInitials(user.firstName, user.lastName)}
                      </Avatar>
                      <Typography>
                        {user.firstName} {user.lastName}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell>{user.phone || '-'}</TableCell>
                  <TableCell>{getRoleChip(user.role)}</TableCell>
                  <TableCell>
                    <Chip 
                      label={user.isEmployee ? 'Oui' : 'Non'}
                      color={user.isEmployee ? 'success' : 'default'}
                      size="small"
                      variant="outlined"
                    />
                  </TableCell>
                  <TableCell>
                    <Switch
                      checked={user.isActive !== false}
                      onChange={() => handleToggleActive(user.id, user.isActive !== false)}
                      size="small"
                      color="primary"
                      disabled={
                        (user.role === 'superadmin' && currentUser.role !== 'superadmin') ||
                        (currentUser.role !== 'superadmin' && currentUser.role !== 'admin' && currentUser.role !== 'manager')
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    {user.role === 'superadmin' && currentUser.role !== 'superadmin' ? (
                      <Chip 
                        label="Protégé" 
                        color="error" 
                        size="small"
                        icon={<Lock />}
                      />
                    ) : (
                      <>
                        <IconButton
                          size="small"
                          onClick={() => openEditDialog(user)}
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            if (user.role === 'superadmin' && currentUser.role !== 'superadmin') {
                              alert('Vous ne pouvez pas modifier un compte Super Admin');
                              return;
                            }
                            setAnchorEl(e.currentTarget);
                            setSelectedUser(user);
                          }}
                        >
                          <MoreVert />
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Menu contextuel */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => {
          handleResetPassword(selectedUser?.id);
          setAnchorEl(null);
        }}>
          <Lock sx={{ mr: 1, fontSize: 20 }} />
          Réinitialiser mot de passe
        </MenuItem>
        <MenuItem onClick={() => {
          handleDeleteUser(selectedUser?.id);
          setAnchorEl(null);
        }}>
          <Delete sx={{ mr: 1, fontSize: 20 }} />
          Supprimer
        </MenuItem>
      </Menu>

      {/* Dialog de création */}
      <Dialog open={createDialog} onClose={() => setCreateDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Nouvel Utilisateur</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Prénom"
                value={newUser.firstName}
                onChange={(e) => setNewUser({...newUser, firstName: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Nom"
                value={newUser.lastName}
                onChange={(e) => setNewUser({...newUser, lastName: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="email"
                label="Email"
                value={newUser.email}
                onChange={(e) => setNewUser({...newUser, email: e.target.value})}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="password"
                label="Mot de passe"
                value={newUser.password || ''}
                onChange={(e) => setNewUser({...newUser, password: e.target.value})}
                required
                helperText="Minimum 6 caractères"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Téléphone"
                value={newUser.phone}
                onChange={(e) => setNewUser({...newUser, phone: e.target.value})}
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth required>
                <InputLabel>Rôle</InputLabel>
                <Select
                  value={newUser.role}
                  onChange={(e) => setNewUser({...newUser, role: e.target.value})}
                  label="Rôle"
                >
                  {currentUser.role === 'superadmin' && (
                    <MenuItem value="superadmin">Super Admin</MenuItem>
                  )}
                  <MenuItem value="admin">Administrateur</MenuItem>
                  <MenuItem value="manager">Gestionnaire</MenuItem>
                  <MenuItem value="contractor">Sous-traitant</MenuItem>
                  <MenuItem value="technician">Technicien</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newUser.isEmployee}
                    onChange={(e) => setNewUser({...newUser, isEmployee: e.target.checked})}
                    color="primary"
                  />
                }
                label="Employé de l'entreprise (peut se voir affecter des véhicules)"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCreateDialog(false)}>
            Annuler
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateUser}
            disabled={!newUser.firstName || !newUser.lastName || !newUser.email}
          >
            Créer
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog d'édition */}
      <Dialog open={editDialog} onClose={() => setEditDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Modifier l'utilisateur</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Prénom"
                value={editUser.firstName}
                onChange={(e) => setEditUser({...editUser, firstName: e.target.value})}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Nom"
                value={editUser.lastName}
                onChange={(e) => setEditUser({...editUser, lastName: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                type="email"
                label="Email"
                value={editUser.email}
                onChange={(e) => setEditUser({...editUser, email: e.target.value})}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Téléphone"
                value={editUser.phone}
                onChange={(e) => setEditUser({...editUser, phone: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nouveau mot de passe"
                type="password"
                placeholder="Laisser vide pour ne pas modifier"
                value={editUser.password || ''}
                onChange={(e) => setEditUser({...editUser, password: e.target.value})}
                helperText="Minimum 6 caractères. Laisser vide pour conserver l'actuel"
              />
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Rôle</InputLabel>
                <Select
                  value={editUser.role}
                  onChange={(e) => setEditUser({...editUser, role: e.target.value})}
                  label="Rôle"
                  disabled={editUser.role === 'superadmin' && currentUser.role !== 'superadmin'}
                >
                  {currentUser.role === 'superadmin' && (
                    <MenuItem value="superadmin">Super Admin</MenuItem>
                  )}
                  <MenuItem value="admin">Administrateur</MenuItem>
                  <MenuItem value="manager">Gestionnaire</MenuItem>
                  <MenuItem value="contractor">Sous-traitant</MenuItem>
                  <MenuItem value="technician">Technicien</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={editUser.isEmployee || false}
                    onChange={(e) => setEditUser({...editUser, isEmployee: e.target.checked})}
                    color="primary"
                  />
                }
                label="Employé de l'entreprise (peut se voir affecter des véhicules)"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialog(false)}>
            Annuler
          </Button>
          <Button variant="contained" onClick={handleEditUser}>
            Enregistrer
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Users;